import React, {ComponentProps, useMemo} from "react";
import {Box, Button, InputAdornment} from "@mui/material";
import {SetState} from "../../util/FormHandlers";


export function DateFieldAdornment({setDate, specialDays, children, ...props}: {
    setDate: SetState<string | undefined>,
    specialDays: {
        label: string,
        date: () => string,
    }[],
} & ComponentProps<typeof InputAdornment>) {
    const withHandlers = useMemo(() => {
        return specialDays.map(day => ({
            ...day,
            onClick: () => setDate(day.date()),
        }));
    }, [setDate, specialDays]);

    return (
        <InputAdornment {...props}>
            {children}
            <Box sx={{ml: 1}}>
                {withHandlers.map(({label, onClick}) => (
                    <Button
                        key={label}
                        onClick={onClick}
                        variant="text"
                        size="small"
                    >{label}</Button>
                ))}
            </Box>
        </InputAdornment>
    );
}

export function createDateFieldAdornment(
    setDate: SetState<string | undefined>,
    specialDays: { label: string, date: () => string }[],
) {
    return function ExpDateAdornment(props: React.ComponentProps<typeof InputAdornment>) {
        return (
            <DateFieldAdornment
                {...props}
                setDate={setDate}
                specialDays={specialDays}
            />
        );
    };
}